module.exports = __webpack_public_path__ + "static/media/eduGreen.71029cbd.svg";